/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import EditTriggerModel from '../Modals/TriggerModal/EditTriggerModel'
import EditActionModel from '../Modals/ActionModal/EditActionModel'
import EditImageModel from '../Modals/ImageModal/EditImageModel'
import EditVideoModel from '../Modals/VideoModal/EditVideoModel'

import EditStaffModel from '../../../../Staff/components/EditModal'
import EditTaskModel from '../../../../StaffTasks/components/EditModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const params = useParams()
  const [apps, setApps] = useState()
  const [appData, setappData] = useState({})
  const [events, setEvents] = useState([])
  const [loader, setloader] = useState(true)
  const [allStaff, setAllStaff] = useState([])
  const [staff, setStaff] = useState()
  const [tasks, setTasks] = useState()
  const [app_collection, setApp_collection] = useState([])
  const [appTriggerModel, setAppTriggerModel] = useState([])

  const getStaff = async () => {
    const { response } = await AppService.user.GetTeam()

    if (response) {
      setAllStaff(response.data)
    } else {
      setAllStaff([])
    }
  }

  const getApps = async () => {
    const { response, error } = await AppService.app.superadmin_apps()

    if (response) {
      setApps(response?.data)
    }
  }

  const getApp = async () => {
    const { response, error } = await AppService.app.filter({
      query: `_id=${params.app_id}`,
    })
    if (response) {
      setappData(response.data)
      setStaff(response?.staff)
      setTasks(response?.tasks)
      const event_data = response.events.map((event) => ({
        ...event,
        label: event.name,
        value: event._id,
      }))
      setEvents(event_data)
      setloader(false)
    } else {
      setloader(false)
    }
  }
  const onLoad = () => {
    getAppCollection()
    getApp()
    getApps()
    getStaff()
    GetAppTriggerModel()
  }
  useEffect(onLoad, [])

  const getAppCollection = async () => {
    const { response } = await AppService.AppCollections.get()
    if (response) {
      setApp_collection(response.data)
    } else {
      setApp_collection([])
    }
    // setloader(false)
  }
  const GetAppTriggerModel = async () => {
    const { response, error } = await AppService.app_trigger_model.get()
    if (response) {
      setAppTriggerModel(response.data)
    } else {
      setAppTriggerModel([])
    }
  }
  // get apps collection by app_type
  const getAppsCollection = (app_type) => {
    const apps = app_collection.filter((item) => item.type.includes(app_type))
    return apps
  }

  // get single app collection by app_collection_id
  const getSingleAppCollection = (app_collection_id) => {
    const app = app_collection.find((item) => item._id === app_collection_id)
    return app
  }

  const handleImageDelete = async (index) => {
    const data = appData.images
    data.splice(index, 1)
    const payload = {
      _id: appData._id,
      images: [...data],
    }
    // console.log(payload)

    const { response } = await AppService.app.update({
      payload: payload,
    })
    if (response) onLoad()
  }
  const handleVideoDelete = async (index) => {
    const data = appData.videos
    data.splice(index, 1)
    const payload = {
      _id: appData._id,
      videos: [...data],
    }
    // console.log(payload)

    const { response } = await AppService.app.update({
      payload: payload,
    })
    if (response) onLoad()
  }
  const handleTriggerDelete = async (index) => {
    const data = appData.triggers
    data.splice(index, 1)
    const payload = {
      _id: appData._id,
      triggers: [...data],
    }
    // console.log(payload)

    const { response } = await AppService.app.update({
      payload: payload,
    })
    if (response) onLoad()
  }
  const handleActionsDelete = async (index) => {
    const data = appData.actions
    data.splice(index, 1)
    const payload = {
      _id: appData._id,
      actions: [...data],
    }
    // console.log(payload)

    const { response } = await AppService.app.update({
      payload: payload,
    })
    if (response) onLoad()
  }
  const handleDocDelete = async (index) => {
    const data = appData.docs
    data.splice(index, 1)
    const payload = {
      _id: appData._id,
      docs: [...data],
    }
    // console.log(payload)

    const { response } = await AppService.app.update({
      payload: payload,
    })
    if (response) onLoad()
  }
  const handleEventDelete = async (index) => {
    const data = appData.events
    data.splice(index, 1)
    const payload = {
      _id: appData._id,
      events: [...data],
    }
    // console.log(payload)

    const { response } = await AppService.app.update({
      payload: payload,
    })
    if (response) onLoad()
  }
  const handleConversationProviderDelete = async (index) => {
    const data = appData.conversation_providers
    data.splice(index, 1)
    const payload = {
      _id: appData._id,
      conversation_providers: [...data],
    }
    // console.log(payload)

    const { response } = await AppService.app.update({
      payload: payload,
    })
    if (response) onLoad()
  }
  return {
    loader: loader,
    appData: appData,
    apps: apps,
    allStaff: allStaff,
    events: events,
    handleRefresh: onLoad,
    ImageDataTableData: {
      columns: [
        { Header: 'image', accessor: 'image' },
        { Header: 'type', accessor: 'type' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: appData?.images?.map((data, index) => ({
        image: <img src={data.image} height={'50px'} />,
        type: data?.type?.label,
        action: (
          <MDBox>
            <EditImageModel
              editData={data}
              index={index}
              appData={appData}
              handleRefresh={onLoad}
            />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleImageDelete(index)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
    VideoDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'link', accessor: 'link' },
        { Header: 'type', accessor: 'type' },

        { Header: 'Action', accessor: 'action' },
      ],

      rows: appData?.videos?.map((data, index) => ({
        name: data.name,
        link: data.link,
        type: data.type,
        action: (
          <MDBox>
            <EditVideoModel
              editData={data}
              index={index}
              appData={appData}
              handleRefresh={onLoad}
            />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleVideoDelete(index)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },

    TriggerDataTableData: {
      columns: [
        { Header: 'App', accessor: 'app' },
        // { Header: 'Plans', accessor: 'plans' },
        { Header: 'Collection', accessor: 'app_collection_id' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: appData?.triggers?.map((data, index) => ({
        app: data.name,
        // plan: data?.plans?.join('\n '),
        app_collection_id: getSingleAppCollection(data?.app_collection_id)?.name,
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleTriggerDelete(index)}
            >
              Delete
            </MDButton>
            <EditTriggerModel
              editData={data}
              index={index}
              appData={appData}
              handleRefresh={onLoad}
              appCollections={getAppsCollection('triggers')}
              appTriggerModel={appTriggerModel}
            />
          </MDBox>
        ),
      })),
    },

    ActionDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'Collection', accessor: 'app_collection_id' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: appData?.actions?.map((data, index) => ({
        name: data.name,
        app_collection_id: getSingleAppCollection(data?.app_collection_id)?.name,
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleActionsDelete(index)}
            >
              Delete
            </MDButton>
            <EditActionModel
              editData={data}
              index={index}
              appData={appData}
              handleRefresh={onLoad}
              appCollections={getAppsCollection('actions')}
            />
          </MDBox>
        ),
      })),
    },
    DocDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: appData?.docs?.map((data, index) => ({
        name: data.name,
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDocDelete(index)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
    EventDataTableData: {
      columns: [
        { Header: 'event', accessor: 'event' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: appData?.events?.map((data, index) => ({
        event: data.event.label,
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleEventDelete(index)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
    ConversationprovidersDataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: appData?.conversation_providers?.map((data, index) => ({
        name: data.name,
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleConversationProviderDelete(index)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
    TasksTable: {
      columns: [
        { Header: 'Task', accessor: 'name' },
        { Header: 'Staff', accessor: 'staff' },
        { Header: 'App', accessor: 'app' },
        { Header: 'Status', accessor: 'status' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: tasks?.map((data) => ({
        name: data.name,
        staff: data?.staff?.map((item) => item?.username).join(', '),
        app: data?.app_name,
        status: data?.status?.label,
        action: (
          <MDBox>
            <EditTaskModel staff={staff} apps={apps} data={data} handleRefresh={onLoad} />
            {/* <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton> */}
          </MDBox>
        ),
      })),
    },
    StaffTable: {
      columns: [
        { Header: 'Name', accessor: 'username' },
        { Header: 'Roles', accessor: 'roles' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: staff?.map((data) => ({
        username: data.username,
        roles: data.roles.join(', '),
        action: (
          <MDBox>
            <EditStaffModel data={data} handleRefresh={onLoad} />
            {/* <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton> */}
          </MDBox>
        ),
      })),
    },
  }
}
